<template>
  <div class="base_box store-collection-binding">
    <div class="base_content store-collection-tabs admin-tabs-bar">
      <el-tabs class="admin-tabs--navigation" :value="tab" @tab-click="switchTab">
        <el-tab-pane label="微信收款" name="wechat" />
        <el-tab-pane v-if="alipayAllowed" label="支付宝收款" name="alipay" />
      </el-tabs>
    </div>
    <WechatStoreMerchantBinding v-if="tab === 'wechat'" />
    <AlipayStoreMerchantBinding v-else embedded />
  </div>
</template>

<script>
import WechatStoreMerchantBinding from './wechat/store_merchant_binding.vue';
import AlipayStoreMerchantBinding from './alipay/store_merchant_binding.vue';
import { isRegionScope } from '@/views/apps/weishop/region/utils/regionApiMap';

// 门店配置：同一入口按页签管理门店的微信与支付宝收款账户，两个页签直接复用原有页面。
// 支付宝接口按「支付宝进件」菜单授权，没有该菜单的账号不显示支付宝页签。
export default {
  name: 'StoreCollectionBinding',
  components: { WechatStoreMerchantBinding, AlipayStoreMerchantBinding },
  computed: {
    alipayAllowed() {
      const target = `${isRegionScope() ? '/region' : '/weishop'}/merchants/setting/alipay/applyment`;
      const has = (nodes) => (nodes || []).some((node) => node && (node.path === target || has(node.children)));
      return has(this.$store.getters.menuTree);
    },
    tab() {
      return this.$route.query.tab === 'alipay' && this.alipayAllowed ? 'alipay' : 'wechat';
    },
  },
  methods: {
    // 页签写进地址，刷新和从支付宝进件页跳转都能落在对应页签。
    switchTab(pane) {
      if (pane.name === this.tab) return;
      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, tab: pane.name } });
    },
  },
};
</script>

<style lang="less" scoped>
.store-collection-tabs { margin-bottom: var(--admin-section-gap, 10px); padding-bottom: 0; border-radius: 6px 6px 0 0; }
.store-collection-binding ::v-deep .wechat-store-merchant-binding-page > .searchHead484848,
.store-collection-binding ::v-deep .alipay-store-merchant-binding-page > .searchHead484848 { border-radius: 0 0 6px 6px; padding-top: 10px; }
.store-collection-tabs ::v-deep .el-tabs__header { margin-bottom: 0; }
</style>
